/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { groupDataSchema } from "./groupDataSchema.ts";
import { z } from "zod";

export const userInfoSchema = z.object({
      "email": z.string().email().describe("Adresse email de l'utilisateur").optional(),
  "firstName": z.string().describe("Prénom de l'utilisateur").optional(),
  "lastName": z.string().describe("Nom de famille de l'utilisateur").optional(),
  "fonction": z.string().describe("Fonction de l'utilisateur").optional(),
  "groups": z.array(z.lazy(() => groupDataSchema).describe("Liste des logiciels attribués au membre dans l'organisation")).optional()
      })